// Action Types
export const FETCH_TEMPLATES_REQUEST = 'FETCH_TEMPLATES_REQUEST'
export const FETCH_TEMPLATES_SUCCESS = 'FETCH_TEMPLATES_SUCCESS'
export const FETCH_TEMPLATES_FAILURE = 'FETCH_TEMPLATES_FAILURE'

export const CREATE_TEMPLATES_REQUEST = 'CREATE_TEMPLATES_REQUEST'
export const CREATE_TEMPLATES_SUCCESS = 'CREATE_TEMPLATES_SUCCESS'
export const CREATE_TEMPLATES_FAILURE = 'CREATE_TEMPLATES_FAILURE'

export const UPDATE_TEMPLATES_REQUEST = 'UPDATE_TEMPLATES_REQUEST'
export const UPDATE_TEMPLATES_SUCCESS = 'UPDATE_TEMPLATES_SUCCESS'
export const UPDATE_TEMPLATES_FAILURE = 'UPDATE_TEMPLATES_FAILURE'

export const DELETE_TEMPLATES_REQUEST = 'DELETE_TEMPLATES_REQUEST'
export const DELETE_TEMPLATES_SUCCESS = 'DELETE_TEMPLATES_SUCCESS'
export const DELETE_TEMPLATES_FAILURE = 'DELETE_TEMPLATES_FAILURE'

export const fetchTemplates = tenant => {
  return async dispatch => {
    dispatch({ type: FETCH_TEMPLATES_REQUEST })

    try {
      const res = await fetch(tenant.getApiUrl('templates'), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      if (!res.ok) throw new Error('Failed to retrieve templates')

      const data = await res.json()
      dispatch({
        type: FETCH_TEMPLATES_SUCCESS,
        payload: data.res.data || []
      })
    } catch (err) {
      dispatch({
        type: FETCH_TEMPLATES_FAILURE,
        payload: err.message
      })
    }
  }
}

export const fetchTemplatesByCategory = (tenant, category) => {
  return async dispatch => {
    dispatch({ type: FETCH_TEMPLATES_REQUEST })

    try {
      const res = await fetch(`${tenant.getApiUrl(`templates`)}/${category}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      if (!res.ok) throw new Error('Failed to retrieve category templates')

      const data = await res.json()
      dispatch({
        type: FETCH_TEMPLATES_SUCCESS,
        payload: data.res.data || []
      })
    } catch (err) {
      dispatch({
        type: FETCH_TEMPLATES_FAILURE,
        payload: err.message
      })
    }
  }
}

export const createTemplate = (tenant, templateData) => {
  return async dispatch => {
    dispatch({ type: CREATE_TEMPLATES_REQUEST })

    try {
      const res = await fetch(tenant.getApiUrl('templates'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(templateData)
      })

      if (!res.ok) throw new Error('Failed to create template')

      const data = await res.json()

      dispatch({
        type: CREATE_TEMPLATES_SUCCESS,
        payload: data.res.data
      })
    } catch (err) {
      dispatch({
        type: CREATE_TEMPLATES_FAILURE,
        payload: err.message
      })
    }
  }
}

export const updateTemplate = (tenant, id, body) => {
  return async dispatch => {
    dispatch({ type: UPDATE_TEMPLATES_REQUEST })

    try {
      const res = await fetch(`${tenant.getApiUrl(`templates`)}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ content: body })
      })

      if (!res.ok) throw new Error('Failed to update template')

      const data = await res.json()
      
      dispatch({
        type: UPDATE_TEMPLATES_SUCCESS,
        payload: data.res.data
      })
    } catch (err) {
      dispatch({
        type: UPDATE_TEMPLATES_FAILURE,
        payload: err.message
      })
    }
  }
}

export const deleteTemplate = (tenant, id) => {
  return async dispatch => {
    dispatch({ type: DELETE_TEMPLATES_REQUEST })

    try {
      const res = await fetch(`${tenant.getApiUrl(`templates`)}/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      if (!res.ok) throw new Error('Failed to delete template')

      await res.json()

      dispatch({
        type: DELETE_TEMPLATES_SUCCESS,
        payload: id
      })
    } catch (err) {
      dispatch({
        type: DELETE_TEMPLATES_FAILURE,
        payload: err.message
      })
    }
  }
}
